export const surfaceColor = '#0b1022';

export const defaultSections = {
    nav: true,
    hero: true,
    icons: true,
    vehicles: true,
    testimonials: true,
    why: true,
    photos: true,
    email: true,
    footer: true,
    adBanner: true,
};

export const initialContent = {
    theme: {
        name: 'Midnight',
        accent: '#7c3aed',
        background: '#0b1020',
        text: '#e2e8f0',
    },
    nav: {
        accent: '#6366f1',
        backgroundMode: 'gradient',
        backgroundColor: '#0b1022',
        gradientColor: '#0b1022',
        brand: 'Fleetify',
        badge: 'Live booking',
        cta: 'Book now',
        links: ['Home', 'View All Rentals', 'Locations', 'Reviews', 'About Us'],
        logo: '',
        logoWidth: '',
        logoHeight: '',
    },
    hero: {
        accent: '#7c3aed',
        headline: 'RENT A CAR!',
        subhead: 'Book faster with contactless pickup, verified insurance, and live availability.',
        ctaPrimary: 'Make reservation',
        ctaSecondary: 'View map',
    },
    icons: {
        accent: '#7c3aed',
        iconColor: '#7c3aed',
        backgroundMode: 'gradient',
        backgroundColor: '#0b1022',
        gradientColor: '#0b1022',
        textColor: '#e2e8f0',
        title: 'Interested in Renting with Us',
        ctaLabel: 'Call us Today',
        items: [
            { title: 'Easy Bookings', description: 'Reserve in minutes with a few taps.', icon: '📱' },
            { title: 'Affordable Pricing', description: 'Transparent rates with no hidden fees.', icon: '💸' },
            { title: "1000's of Happy Renters", description: 'Trusted experiences from repeat customers.', icon: '⭐' },
            { title: 'Book Now, Pay Later', description: 'Secure your ride and settle payment at pickup.', icon: '⏱️' },
        ],
    },
    vehicles: {
        accent: '#7c3aed',
        backgroundMode: 'gradient',
        backgroundColor: '#0b1022',
        gradientColor: '#0b1022',
        textColor: '#e2e8f0',
        cardBackgroundColor: '#0f172a',
        badge: 'Book now',
        heading: 'Find Your Drive',
        subhead: "Explore Florida's most affordable car rentals for as low as $50 per day.",
        items: [
            {
                title: 'Chevrolet Equinox',
                price: '$65',
                rate: '/Day',
                note: 'Free Cancellation',
                image: 'https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=800&q=80',
            },
            {
                title: 'Chevrolet Sonic',
                price: '$50',
                rate: '/Day',
                note: 'Free Cancellation',
                image: 'https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=800&q=80',
            },
            {
                title: 'Chevrolet Cruze',
                price: '$50',
                rate: '/Day',
                note: 'Free Cancellation',
                image: 'https://images.unsplash.com/photo-1511919884226-fd3cad34687c?auto=format&fit=crop&w=800&q=80',
            },
            {
                title: 'Chevrolet Cruze',
                price: '$50',
                rate: '/Day',
                note: 'Free Cancellation',
                image: 'https://images.unsplash.com/photo-1489515217757-5fd1be406fef?auto=format&fit=crop&w=800&q=80',
            },
            {
                title: 'Kia Soul',
                price: '$75',
                rate: '/Day',
                note: 'Free Cancellation',
                image: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=800&q=80',
            },
            {
                title: 'Buick Verano',
                price: '$50',
                rate: '/Day',
                note: 'Free Cancellation',
                image: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=800&q=80',
            },
            {
                title: 'Ford Edge',
                price: '$65',
                rate: '/Day',
                note: 'Free Cancellation',
                image: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=800&q=80',
            },
            {
                title: 'Range Rover',
                price: '$150',
                rate: '/Day',
                note: 'Free Cancellation',
                image: 'https://images.unsplash.com/photo-1493238792000-8113da705763?auto=format&fit=crop&w=800&q=80',
            },
            {
                title: 'Chevrolet Equinox',
                price: '$65',
                rate: '/Day',
                note: 'Free Cancellation',
                image: 'https://images.unsplash.com/photo-1489515217757-5fd1be406fef?auto=format&fit=crop&w=800&q=80',
            },
        ],
    },
    testimonials: {
        accent: '#7c3aed',
        backgroundMode: 'gradient',
        backgroundColor: '#0b1022',
        gradientColor: '#0b1022',
        textColor: '#e2e8f0',
        quote: 'We replaced three tools with one page and doubled repeat rentals without adding staff.',
        badge: 'Verified',
    },
    why: {
        accent: '#7c3aed',
        backgroundMode: 'gradient',
        backgroundColor: '#0b1022',
        gradientColor: '#0b1022',
        textColor: '#e2e8f0',
        items: [
            { title: 'Flexible pickup', description: 'Self-service or staffed handoff with instant ID checks.' },
            { title: 'No surprise fees', description: 'Real-time pricing and add-ons displayed before checkout.' },
            { title: 'Always on', description: 'Content, promos, and fleet updates sync automatically.' },
        ],
    },
    photos: {
        accent: '#7c3aed',
        backgroundMode: 'gradient',
        backgroundColor: '#0b1022',
        gradientColor: '#0b1022',
        items: [
            {
                image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=900&q=80',
            },
            {
                image: 'https://images.unsplash.com/photo-1507136566006-cfc505b114fc?auto=format&fit=crop&w=900&q=80',
            },
            {
                image: 'https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=900&q=80',
            },
            {
                image: 'https://images.unsplash.com/photo-1493238792000-8113da705763?auto=format&fit=crop&w=900&q=80',
            },
        ],
    },
    email: {
        accent: '#7c3aed',
        backgroundMode: 'gradient',
        backgroundColor: '#0b1022',
        gradientColor: '#0b1022',
        textColor: '#e2e8f0',
        placeholder: 'Enter email address',
        buttonText: 'Subscribe',
    },
    footer: {
        accent: '#7c3aed',
        backgroundMode: 'gradient',
        backgroundColor: '#0b1022',
        gradientColor: '#0b1022',
        textColor: '#e2e8f0',
        title: 'Your Logo',
        tagline: 'Smarter rentals, faster checkouts, better experiences.',
        badgeText: 'Trusted rental platform',
        contactTitle: 'CONTACT',
        contactEmail: 'support@fleetifysoftware.com',
        contactPhone: '(833) 353-3847',
        hoursTitle: 'Hours',
        hoursDays: 'Monday to Sunday',
        hoursTime: '09:00AM - 08:00PM',
        followTitle: 'Follow Us',
        instagramLabel: 'Instagram',
        instagramUrl: 'https://www.instagram.com',
        facebookLabel: 'Facebook',
        facebookUrl: 'https://www.facebook.com',
    },
    adBanner: {
        accent: '#7c3aed',
        backgroundMode: 'gradient',
        backgroundColor: '#0b1022',
        gradientColor: '#0b1022',
        textColor: '#e2e8f0',
        phone: '(833) 353-3847',
        quote: 'Fleetify made it so easy & affordable to rent a car for my trip',
        author: 'Alex Bash',
    },
};
